import { theme } from '@briq/shared'

export const GlobalStyle = theme.BriqCommonGlobalStyle
